import * as React from 'react';
import './index.css';
import HoverContainer from '@/src/components/HoverContainer';
import lx from '../../statistics';
import { CheckDistancePoi } from '../../types';
import { getAddress } from '../../utils/struct';

interface Props {
  title?: string;
  message?: string;
  poiAddress: any;
  primaryBtnText?: string;
  secondaryBtnText?: string;
  addressWarnPromptText?: string;
  onPrimaryBtnClick?: () => void;
  onSecondaryBtnClick?: () => void;
  onCloseDialog?: () => any;
  isHKStructRegion: boolean;
  hidePrimaryBtn?: boolean;
  hideSecondaryBtn?: boolean;
}

interface IState {
  structAddress: string;
}
export default class AddressDialog extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props);
    const structAddress = getAddress(props.poiAddress, true, this.props.isHKStructRegion);

    this.state = {
      structAddress,
    };
  }

  onCloseDialog = () => {
    this.props.onCloseDialog?.();
  };

  render() {
    const {
      title, message, poiAddress, hidePrimaryBtn, hideSecondaryBtn, addressWarnPromptText
    } = this.props;
    const { structAddress } = this.state;
    return (
      <modal>
        <view className="dialog-mask">
          <view
            className="dialog-container"
            onClick={() => {
            //do noting 防止点击内容区域弹窗消失
            }}
          >
            <view className="dialog-icon-container">
              <view className="dialog-icon" onClick={this.onCloseDialog}>
                <image
                  src="assets://address/dialogClose.png"
                  className="dialog-icon-close"
                />
              </view>
            </view>
            <view className="dialog-content">
              {title ? <text className="dialog-title" content={title} /> : null}
              {message ? <text className="dialog-message" content={message} /> : null}
            </view>
            <view className="dialog-address-container">
              <view className="address-info">
                <view style={{ alignItems: 'center' }}>
                  <image
                    src="assets://address/address_loc.png"
                    className="dialog-icon-location"
                  />
                  <view style={{ flexDirection: 'column' }}>
                    {poiAddress?.premise ? <text className="dialog-poi-name" content={poiAddress.premise} /> : null}
                    {structAddress && <text className="dialog-poi-address" content={structAddress} />}
                  </view>
                </view>
                {
                  addressWarnPromptText && (
                    <view className="address-prompt-layout">
                      <image className="icon-address-prompt" src="assets://address/icon_address_prompt.png" />
                      <text className="dialog-poi-address-prompt">{addressWarnPromptText}</text>
                    </view>
                  )
                }

              </view>
            </view>
            <view className="dialog-button-container">
              {
                !hidePrimaryBtn && (
                  <HoverContainer
                    wrap
                    onClick={() => this.props.onPrimaryBtnClick?.()}
                    wrapStyle={{ marginBottom: 10 }}
                    style={{ borderRadius: 25 }}
                  >
                    <text
                      className="dialog-button dialog-button-top"
                      content={this.props.primaryBtnText}
                    />
                  </HoverContainer>
                )
              }

              {
                !hideSecondaryBtn && (
                  <HoverContainer
                    wrap
                    onClick={() => this.props.onSecondaryBtnClick?.()}
                    style={{ borderRadius: 25 }}
                  >
                    <text
                      className="dialog-button "
                      content={this.props.secondaryBtnText}
                    />
                  </HoverContainer>
                )
              }

            </view>
          </view>
        </view>
      </modal>
    );
  }
}
